import { Grid, Tooltip } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import {
  BasicAccordion,
  Breadcrumbs,
  CardComponent,
  // CareGapsDistributionChart,
  Chip,
  DottedText,
  NoDataVisual,
  OverviewCard,
  PageTitleAndSubTitle,
  SvgCalendar,
  Table,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { ArrowDownward } from '@mui/icons-material';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';
import { observer } from 'mobx-react';
import React, { useEffect, useState } from 'react';
import {
  CareQualityMeasures,
  CareQualityOverView,
  formatBenachMarkChart,
  getCareGapMemberSummaryIds,
  getCareQualityDistributions,
  getCareQualityOverViewCardData,
} from '../../core-utils/helper-utils/careQualityHelper';
import careQualityMessages from '../../core-utils/messages/careQualityMessages';
import { useStores } from '../../stores';
import Loader from '../../_components/molecules/Loader';
import { pageScrollDown } from '../SummaryPage';
import ReportsModal from '../../_components/organisms/ReportsModal';
import TabSelection from '../../_components/molecules/TabSelection';
import RecommendationsTab from '../../_components/organisms/RecommendationsTab';
import { getRecommendationsData } from '../../core-utils/helper-utils/recommendationsTabHelper';
import { useNavigate } from 'react-router-dom';
import { CARE_QUALITY, CARE_QUALITY_INTERNAL } from '../../core-utils/routes';
// import { getInfoIcon } from '../../core-utils/helper-utils/infoIconHelper';
import { toJS } from 'mobx';
import properties from '../../core-utils/properties';
import {
  checkUserAccess,
  UserAccessConstants,
} from '../../core-utils/helper-utils/userAccess';
import CohortDetailsModal from '../../_components/organisms/CohortDetailsModalNew';
import FeatureAccessModal from '../../_components/organisms/FeatureAccessModal';
import { formatDate } from '../../core-utils/helper-utils/helper';
import moment from 'moment';
import { downloadPdf } from '../../core-utils/helper-utils/downloadPdfHelper';
import { useAPIPayload } from '../../core-utils/helper-utils/apiPayloadHelper';
import Snackbar from '../../_components/atoms/Snackbar';
import { AlertColor as MuiColor } from '@mui/material/Alert';
import componentConstants from '../../core-utils/messages/componentConstants';
import AiSummaryCard from '../../_components/molecules/AiSummaryCard';
import axios from 'axios';
import allScreenLabel from '../../core-utils/messages/screenNamesForPrompts';
import { useCohortModal } from '../../core-utils/custom-hooks/useCohortModal';
import CohortFilterBar from '../../_components/molecules/CohortFilterBar';
import { useCohortOnPageLoad } from '../../core-utils/custom-hooks/useCohortPageOnLoad';
import { useInitializeDuration } from '../../core-utils/custom-hooks/useInitializeDuration';

export const getLast12MonthsRange = (dateString: any) => {
  const endDate = moment(dateString, 'YYYY-MM-DD');

  const startDate = moment(dateString, 'YYYY-MM-DD')
    .subtract(1, 'year')
    .startOf('month')
    .add(1, 'month');

  return (
    <>
      <SvgCalendar
        height="16px"
        width="16px"
        color={'#7C98B6'}
        style={{
          marginRight: '8px',
        }}
      />
      <Typography fontSize="12px" lineHeight="20px" margin="0px 4px 0px 0px">
        Paid Date:
      </Typography>
      <Typography
        fontSize="12px"
        lineHeight="20px"
        fontType="bold"
        margin="0px 4px 0px 0px"
      >
        {formatDate(startDate.toString(), 'MMM YYYY')} -{' '}
        {formatDate(endDate.toString(), 'MMM YYYY')}
      </Typography>
    </>
  );
};

const CareQualityPage: React.FC = observer(({ }) => {
  const useStyles = makeStyles()({
    root: {
      display: 'flex',
      flexDirection: 'column',
      padding: '40px 0px 66px 63px',
    },
    tooltip: {
      backgroundColor: patientAccessTheme.palette.grey[900],
      padding: '10px',
      fontSize: '13px',
      fontFamily: 'Inter',
      fontWeight: 400,
      lineHeight: '16px',
      color: patientAccessTheme.palette.status.white,
      maxWidth: 365,
    },
    arrow: {
      color: patientAccessTheme.palette.grey[900],
      marginLeft: '50px',
    },
    popper: {
      marginTop: '-8px',
      marginLeft: '-34px',
    },
    duration: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: 'center',
      width: '230px',
      height: '27px',
      background: patientAccessTheme.palette.status.white,
      border: `1px solid ${patientAccessTheme.palette.grey[300]}`,
      borderRadius: '4px',
      color: patientAccessTheme.palette.text.highemphasis,
      padding: '0px',
    },
  });

  const { classes } = useStyles();
  const navigate = useNavigate();
  const screenName = allScreenLabel;

  // const serviceYear = 2021;
  const messages = careQualityMessages.CARE_QUALITY_PAGE;
  const [loading, setLoading] = useState<boolean>(false);
  const [
    allDistributions,
    setAllDistributions,
  ] = useState<CareQualityMeasures>();
  const [
    benchMarkDistribution,
    setBenchMarkDistribution,
  ] = useState<CareQualityMeasures>();
  const [benchmarkChartData, setbenchmarkChartData] = useState<any>();
  const [isAllDataAvaialble, setIsAllDataAvailable] = useState<boolean>(false);

  const employerGroupStore = useStores().employerGroupStore;
  const cohortDetailsStore = useStores().cohortDetailsStore;
  const loginPageStore = useStores().loginPageStore;
  const { open, openModal, closeModal, isEditMode } = useCohortModal();
  useInitializeDuration(employerGroupStore.employerGroupResponseData);

  const [openReportsModal, setOpenReportsModal] = useState(false);
  const [openFeatureAccessModal, setOpenFeatureAccessModal] = useState(false);

  const [selectedTabIndex, setSelectedTabIndex] = useState<number>(0);
  const [
    careQualityOverview,
    setCareQualityOverview,
  ] = useState<CareQualityOverView>();

  const [recommendationLoading, setRecommendationLoading] = useState<boolean>(
    false,
  );
  const [recommendationFetched, setRecommendationFetched] = useState<boolean>(
    false,
  );
  const snackBarMessages = componentConstants.ORGANISMS.REPORTS_MODAL;
  const [activeAskAi, setActiveAskAi] = useState<boolean>(false);
  const [aiSummaryData, setAiSummaryData] = useState<
    { title: string; description: string }[]
  >([]);
  const [aiLoading, setAiLoading] = useState<boolean>(false);
  const { totalResults, isInitializing } = useCohortOnPageLoad({
    fetchTotalResults: () =>
      getCareGapMemberSummaryIds({
        eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
        max_claim_date:
          employerGroupStore?.employerGroupResponseData?.max_claim_date,
        startDate: employerGroupStore?.selectedDuration?.startDate,
        endDate: employerGroupStore?.selectedDuration?.endDate,
      }),
    enabled:
      !!employerGroupStore?.selectedDuration?.startDate &&
      !!employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
  });

  //snackbar
  const handleOpenSnackBar = (
    message: string,
    severity: MuiColor,
    duration: number | null,
  ) => {
    setSnackbarState({
      open: true,
      message: message,
      severity: severity,
      duration: duration,
    });
  };

  const handleCloseSnackBar = (
    event?: React.SyntheticEvent,
    reason?: string,
  ) => {
    if (reason === 'clickaway') {
      return;
    }
    setSnackbarState({
      open: false,
      message: '',
      severity: undefined,
      duration: null,
    });
  };

  const [snackbarState, setSnackbarState] = React.useState<{
    open: boolean;
    message: string;
    severity: MuiColor | undefined;
    duration: null | number;
  }>({
    open: false,
    message: '',
    severity: undefined,
    duration: null,
  });

  const payload = useAPIPayload();

  const handleSelectedIndex = (index: number) => {
    setSelectedTabIndex(index);
    if (!recommendationFetched) {
      getRecommendationsData(
        employerGroupStore?.employerGroupResponseData?.eg_nid,
        messages.TITLE,
        recommendedTabStore,
        setRecommendationLoading,
      );
      setRecommendationFetched(true);
    }
  };

  const handleAskAi = () => {
    setActiveAskAi(true);
    getAiSummarizedData();
  };

  const recommendedTabStore = useStores().recommendedTabStore;
  const careQualityStore = useStores().careQualityStore;
  const handleNonCompliantMembersList = (
    careQualityDistributionTableData: any,
  ) => {
    const localCareQualityMeasuresList: string[] = [];
    const localCareQualityMeasuresSubMeasure: Map<string, string> = new Map<
      string,
      string
    >();
    const localCareQualityMeasureRuleID: Map<string, string> = new Map<
      string,
      string
    >();

    careQualityDistributionTableData?.map((careQualityMeasureObject: any) => {
      careQualityMeasureObject?.individualMeasures?.map(
        (individualCareQualityMeasure: any) => {
          localCareQualityMeasuresList.push(
            individualCareQualityMeasure?.individualMeasure,
          );
          localCareQualityMeasuresSubMeasure.set(
            individualCareQualityMeasure?.individualMeasure,
            careQualityMeasureObject?.subMeasure,
          );
          localCareQualityMeasureRuleID.set(
            individualCareQualityMeasure?.individualMeasure,
            individualCareQualityMeasure?.ruleId,
          );
        },
      );
    });

    careQualityStore.removeAllData();
    careQualityStore.setCareQualityMeasuresList(localCareQualityMeasuresList);
    careQualityStore.setCareQualityMeasuresSubMeasure(
      localCareQualityMeasuresSubMeasure,
    );
    careQualityStore.setcareQualityMeasureRuleID(localCareQualityMeasureRuleID);
  };

  const setAllDistributionsFunction = (data: any) => {
    setAllDistributions(data);
    handleNonCompliantMembersList(data?.distribution || []);
  };

  const getAllCharts = async () => {
    const currentStartDate = employerGroupStore?.selectedDuration?.startDate;
    const currentEndDate = employerGroupStore?.selectedDuration?.endDate;

    if (!currentStartDate || !currentEndDate) {
      return;
    }

    setLoading(true);
    try {
      await Promise.all([
        getCareQualityDistributions(
          {
            startDate: currentStartDate,
            endDate: currentEndDate,
            eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
            member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
            max_claim_date:
              employerGroupStore?.employerGroupResponseData?.max_claim_date,
          },
          setAllDistributionsFunction,
          setBenchMarkDistribution,
          setIsAllDataAvailable,
        ),
        getCareQualityOverViewCardData(
          {
            startDate: currentStartDate,
            endDate: currentEndDate,
            eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid,
            member_unique_id_list: cohortDetailsStore.memberUniqueIdList,
            max_claim_date:
              employerGroupStore?.employerGroupResponseData?.max_claim_date,
          },
          setCareQualityOverview,
        ),
      ]);
    } catch (error) {
      handleOpenSnackBar('Failed to load data', 'error', 6000);
    } finally {
      setLoading(false);
    }
  };

  const getTotalMeasures = () => {
    let totalMeasures: number = 0;
    benchmarkChartData?.currentYearData?.map((item: any) => {
      totalMeasures += item.value;
    });
    return totalMeasures;
  };

  const getAiSummarizedData = async () => {
    try {
      setAiLoading(true);

      // ✅ Clean Overview Data
      const cleanOverviewData = {
        totalMeasures: careQualityOverview?.totalMetUnmet,
        totalMet: careQualityOverview?.totalMet,
        totalUnmet: careQualityOverview?.totalUnmet,
        totalEnrollees: careQualityOverview?.totalEnrolles,
      };

      // ✅ Clean Distribution Data
      const cleanDistributionData = allDistributions?.distribution?.map(
        (item: any) => ({
          measure: item?.measure,
          subMeasure: item?.subMeasure,
          met: item?.met,
          unmet: item?.unmet,
          complianceRate: item?.complianceRate,
        }),
      );

      // ✅ Clean Benchmark Chart Data
      const cleanBenchmarkData = benchmarkChartData?.currentYearData?.map(
        (item: any) => ({
          measure: item?.label,
          value: item?.value,
        }),
      );

      const apiResponses = {
        title_1: cleanOverviewData,
        title_2: cleanDistributionData,
        title_3: cleanBenchmarkData,
      };

      let resultArray = []; // ✅ default fallback

      try {
        const response = await axios.post(
          properties.aiqBaseUrl +
          properties.contractBaseUrl +
          properties.getAiSummary,
          {
            screenName: screenName.CARE_QUALITY,
            eg_nid: employerGroupStore?.employerGroupResponseData?.eg_nid?.[0],
            incurredStartDate: null,
            incurredEndDate: null,
            paidStartDate: employerGroupStore?.selectedDuration?.startDate,
            paidEndDate: employerGroupStore?.selectedDuration?.endDate,
            apiData: apiResponses,
          },
        );

        // ✅ Safe extraction
        resultArray = response?.data?.data?.data?.result || [];
        setAiSummaryData(Array.isArray(resultArray) ? resultArray : []);
      } catch (apiError) {
         
        console.error('AI Summary API failed:', apiError);
        // ✅ Optional: show user-friendly message
        handleOpenSnackBar('Failed to load summary', 'warning', 4000);
        setAiSummaryData([]);
      }
    } catch (error: any) {
      handleOpenSnackBar(error, 'error', 6000);
    } finally {
      setAiLoading(false);
    }
  };

  useEffect(() => {
    if (isInitializing) {
      return;
    }
    getAllCharts();
  }, [
    isInitializing,
    employerGroupStore?.employerGroupResponseData?.eg_nid,
    cohortDetailsStore.conditionsDetails,
  ]);

  useEffect(() => {
    setbenchmarkChartData(
      formatBenachMarkChart(benchMarkDistribution?.benchMarkDistribution!),
    );
  }, [benchMarkDistribution]);

  const CareQualityCards = () => {
    const useStyles = makeStyles()({
      root: {
        display: 'flex',
        flexDirection: 'column',
        gap: '1rem',
        width: '1182px',
      },
      tableHeader: {
        height: '48px',
        backgroundColor: patientAccessTheme.palette.grey[100],
        borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
        '&:first-child': {
          paddingLeft: '20px',
        },
        textAlign: 'left',
      },
      tableRow: {
        height: '56px',
        padding: '0px',
        borderBottom: `1px solid ${patientAccessTheme.palette.grey[300]}`,
        '&:first-child': {
          paddingLeft: '38px',
        },
      },
      tooltip: {
        backgroundColor: patientAccessTheme.palette.grey[900],
        padding: '10px',
        fontSize: '13px',
        fontFamily: 'Inter',
        fontWeight: 400,
        lineHeight: '16px',
        color: patientAccessTheme.palette.status.white,
        maxWidth: 365,
      },
      headerText: {
        fontSize: '12px',
        fontHeight: '12px',
        fontWeight: 500,
        color: patientAccessTheme.palette.text.highemphasis,
      },
      queryIconGrid: {
        padding: '10px 0px 10px 22px',
      },
      queryDataOverallGrid: {
        margin: '0px 0px 20px 0px',
        height: '44px',
        backgroundColor: '#FFFFFF',
        border: '1px solid #DADEEF',
        width: '1176px',
        borderRadius: '4px',
        flexWrap: 'nowrap',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      queryDataTypography: {
        padding: '10px 10px',
        height: '44px',
        borderRight: '1px solid #DADEEF',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
      },
      queryDataGrid: {
        maxWidth: '400px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        minWidth: '60px',
      },
      tooltipCohort: {
        backgroundColor: patientAccessTheme.palette.grey[900],
        padding: '10px',
        fontSize: '13px',
        fontFamily: 'Inter',
        fontWeight: 400,
        lineHeight: '16px',
        color: patientAccessTheme.palette.status.white,
      },
      arrow: {
        color: patientAccessTheme.palette.grey[900],
        marginLeft: '50px',
      },
      popper: {
        marginTop: '-20px',
        marginLeft: '-20px',
      },
    });

    const arrowIconStyle = {
      height: '20px',
      width: '20px',
      color: patientAccessTheme.palette.success.greenbg,
      marginBottom: '0px',
    };

    const { classes } = useStyles();
    const cardMessages = careQualityMessages.CARE_QUALITY_PAGE.CARDS;

    const measuresColumns = [
      {
        id: 'individualMeasure',
        accessorKey: 'individualMeasure',
        header: (
          <Typography className={classes.headerText} style={{ width: '235px' }}>
            {'Care Gap Measure'}
          </Typography>
        ),
        footer: 'MEASURES',
        sticky: 'left',
        size: 235,
        cell: ({ getValue, row }: any) => {
          const value = getValue();
          const guideLinks: Record<string, string> = cardMessages.GUIDE_LINK;
          return (
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                alignItems: 'center',
                paddingRight: '20px',
                paddingLeft: '20px',
              }}
            >
              <div
                onClick={() => {
                  if (
                    row?.original?.eligibleCount !== undefined &&
                    row?.original?.eligibleCount === 0
                  ) {
                    return;
                  }

                  const pathDetails: any[] = [];
                  pathDetails.push([
                    'text',
                    'Care Gaps',
                    {
                      color: patientAccessTheme.palette.primary[500],
                      fontWeight: 500,
                    },
                    () => navigate(CARE_QUALITY),
                  ]);
                  pathDetails.push([
                    'text',
                    row?.original?.individualMeasure,
                    {
                      color: patientAccessTheme.palette.text.highemphasis,
                      fontWeight: 600,
                    },
                  ]);
                  careQualityStore.setPathDetails(pathDetails);
                  careQualityStore.setsubMeasure(
                    toJS(
                      careQualityStore.careQualityMeasuresSubMeasure.get(
                        row?.original?.individualMeasure,
                      ),
                    ) || '',
                  );
                  careQualityStore.setcurrentMeasure(
                    row?.original?.individualMeasure,
                  );
                  careQualityStore.setRuleId(row?.original?.ruleId);
                  navigate(CARE_QUALITY_INTERNAL);
                }}
              >
                <DottedText text={value} />
              </div>
              {guideLinks[value] && (
                <div
                  style={{ paddingLeft: '10px' }}
                  onClick={() => window.open(guideLinks[value], '_blank')}
                >
                  <DottedText text={'(Guide)'} />
                </div>
              )}
              {row?.original?.inverseMeasureFlag &&
                row?.original?.inverseMeasureFlag === 'Yes' ? (
                <Tooltip
                  title={
                    'INVERSE MEASURE - A lower calculated performance rate for this measure indicates better clinical care or control. The Non-Compliant numerator option for this measure is the representation of better clinical quality or control.'
                  }
                  classes={{ tooltip: classes.tooltip }}
                  arrow
                >
                  <ArrowDownward style={arrowIconStyle} />
                </Tooltip>
              ) : (
                ''
              )}
            </div>
          );
        },
      },
      {
        id: 'eligibleCount',
        accessorKey: 'eligibleCount',
        header: (
          <Typography className={classes.headerText} style={{ width: '120px' }}>
            {'Eligible'}
          </Typography>
        ),
        footer: 'Eligible Members',
        sticky: 'left',
        cellType: 'none',
        icon: 'none',
        size: 120,
      },
      {
        id: 'measureMetCount',
        accessorKey: 'measureMetCount',
        header: (
          <Typography className={classes.headerText} style={{ width: '92px' }}>
            {'Compliant'}
          </Typography>
        ),
        footer: 'Met Members',
        size: 92,
      },
      {
        id: 'measureNotMetCount',
        accessorKey: 'measureNotMetCount',
        header: (
          <Typography className={classes.headerText} style={{ width: '109px' }}>
            {'Non-Compliant'}
          </Typography>
        ),
        footer: 'Unmet Members',
        cellType: 'TextWithIcon',
        icon: 'info',
        size: 109,
      },
      {
        id: 'measureNotEnoughDataCount',
        accessorKey: 'measureNotEnoughDataCount',
        header: (
          <Typography className={classes.headerText} style={{ width: '109px' }}>
            {'Not Enough Data'}
          </Typography>
        ),
        footer: 'Not Enough Data Members',
        cellType: 'TextWithIcon',
        icon: 'info',
        size: 109,
      },
    ];

    const getChipComponent = (
      chipType: 'Needs Intervention' | 'Good' | 'Average' | 'NA',
      label?: string | React.JSX.Element,
    ) => {
      switch (chipType) {
        case 'Needs Intervention':
          return (
            <Chip
              label={
                <Typography
                  fontSize="12px"
                  lineHeight="15px"
                  fontType="medium"
                  textColor={patientAccessTheme.palette.AIQChips?.textColor1}
                >
                  {label ?? 'Needs Intervention'}
                </Typography>
              }
              backgroundColor={patientAccessTheme.palette.AIQChips?.background1}
              border="0.3px solid rgba(226, 84, 84, 0.5)"
              borderRadius="4px"
              padding="5px 8px"
              height="25px"
              width={label ? '120px' : '150px'}
            />
          );
        case 'Good':
          return (
            <Chip
              label={
                <Typography
                  fontSize="12px"
                  lineHeight="15px"
                  fontType="medium"
                  textColor={patientAccessTheme.palette.AIQChips?.textColor2}
                >
                  {label ?? 'Good'}
                </Typography>
              }
              backgroundColor={patientAccessTheme.palette.AIQChips?.background2}
              border="0.3px solid rgba(0, 130, 114, 0.5)"
              borderRadius="4px"
              padding="5px 8px"
              height="25px"
              width={label ? '120px' : '150px'}
            />
          );

        case 'Average':
          return (
            <Chip
              label={
                <Typography
                  fontSize="12px"
                  lineHeight="15px"
                  fontType="medium"
                  textColor={patientAccessTheme.palette.primary[500]}
                >
                  {label ?? 'Average'}
                </Typography>
              }
              backgroundColor={
                patientAccessTheme.palette.AIQChips?.background15
              }
              border={'0.3px solid' + patientAccessTheme.palette.primary[500]}
              borderRadius="4px"
              padding="5px 8px"
              height="25px"
              width={label ? '120px' : '150px'}
            />
          );

        default:
          return (
            <Chip
              label={
                <Typography
                  fontSize="12px"
                  lineHeight="15px"
                  fontType="medium"
                  textColor={patientAccessTheme.palette.grey[900]}
                >
                  {label ?? 'NA'}
                </Typography>
              }
              backgroundColor={patientAccessTheme.palette.grey[300]}
              border={'0.3px solid' + patientAccessTheme.palette.grey[900]}
              borderRadius="4px"
              padding="5px 8px"
              height="25px"
              width={label ? '120px' : '150px'}
            />
          );
      }
    };

    const checkChipForSubmeasure = (subMeasure: any) => {
      for (const value of subMeasure?.individualMeasures) {
        if (value?.eligibleCount > 0) {
          return true;
        }
      }
      return false;
    };

    return (
      <Grid container className={classes.root}>
        <CohortFilterBar />
        {isAllDataAvaialble ? (
          <>
            <Grid style={{ display: 'flex', marginBottom: '29px' }}>
              <Grid style={{ marginRight: '24px' }}>
                <OverviewCard
                  title={cardMessages.ELIGIBLE_MEASURES}
                  value={getTotalMeasures()?.toString()}
                  rootStyles={{
                    width: '176px',
                    height: '100px',
                  }}
                  showClickHere
                />
              </Grid>

              <Grid style={{ marginRight: '24px' }}>
                <OverviewCard
                  title={cardMessages.NON_COMPLAINT}
                  value={String(careQualityOverview?.totalUnmet)}
                  isMultiValued={true}
                  rightLabelValues={[
                    [
                      cardMessages.ELIGIBLE_POPULATION,
                      String(careQualityOverview?.totalMetUnmet),
                    ],
                    [
                      cardMessages.TOTAL_POPULATION,
                      String(careQualityOverview?.totalEnrolles),
                    ],
                  ]}
                  rootStyles={{
                    width: 'auto',
                  }}
                  labelsMinWidth={'110px'}
                />
              </Grid>
            </Grid>
            {/* <Grid item style={{ marginBottom: '28px' }}>
              <CareGapsDistributionChart
                previousYear={(serviceYear - 1)?.toString()}
                currentYear={serviceYear?.toString()}
                categories={benchmarkChartData?.categories}
                previousYearData={benchmarkChartData?.previousYearData}
                currentYearData={benchmarkChartData?.currentYearData}
                handleOnClick={handleDataPlotOnClick}
              />
            </Grid> */}
            <Grid style={{ display: 'flex' }}>
              <CardComponent
                title={cardMessages.CARE_QUALITY_DISTRIBUTION.TITLE}
                subTitle={cardMessages.CARE_QUALITY_DISTRIBUTION.SUBTITLE}
                width="1176px"
                height="auto"
                body={
                  <div style={{ marginTop: '10px' }}>
                    {allDistributions?.distribution?.map(
                      (measure: any, index: number) => {
                        return (
                          <div key={index} style={{ marginBottom: '20px' }}>
                            <BasicAccordion
                              title={
                                <div
                                  style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                  }}
                                >
                                  <Typography>{measure?.subMeasure}</Typography>
                                  <div
                                    style={{
                                      right: '24px',
                                      position: 'absolute',
                                    }}
                                  >
                                    {checkChipForSubmeasure(measure)
                                      ? getChipComponent(measure?.rank)
                                      : getChipComponent('NA')}
                                  </div>
                                </div>
                              }
                              height="60px"
                              content={
                                <div>
                                  <Table
                                    classNameForTableHeaderRowTop={
                                      classes.tableHeader
                                    }
                                    classNameForTableDataRow={classes.tableRow}
                                    classNameForTableHeader={
                                      classes.tableHeader
                                    }
                                    columns={measuresColumns}
                                    data={measure?.individualMeasures}
                                    onHoverRowData={() => { }}
                                    controlledPageIndex={0}
                                    isManualPagination={true}
                                    tableWidth="1070px"
                                  />
                                </div>
                              }
                            />
                          </div>
                        );
                      },
                    )}
                  </div>
                }
              />
            </Grid>
          </>
        ) : (
          <NoDataVisual content="Historical Claims Data Not Available to capture Care Gaps" />
        )}
      </Grid>
    );
  };

  const [loader] = useState<any>(<Loader />);
  const pathStore = useStores().pathStore;
  const getPath = () => {
    if (pathStore.path.length !== 0) {
      return pathStore.path;
    } else {
      return [];
    }
  };
  const isPageLoading = loading || isInitializing;

  return (
    <>
      {isPageLoading ? (
        loader
      ) : (
        <div>
          <Grid container className={classes.root}>
            {getPath().length !== 0 && (
              <Grid style={{ marginBottom: '20px' }}>
                <Breadcrumbs itemList={getPath()} />
              </Grid>
            )}
            <Grid
              style={{
                marginBottom: '36px',
                width: '1182px',
                position: 'relative',
              }}
            >
              <PageTitleAndSubTitle
                title={messages.TITLE}
                subTitle={messages.SUB_TITLE}
                showDownloadButton
                // downloadButtonAction={() => setOpenReportsModal(true)}
                downloadButtonAction={() => {
                  downloadPdf(
                    'careQualityReport',
                    {
                      employer:
                        employerGroupStore?.employerGroupResponseData
                          ?.employer_group_name,
                      member_unique_id_list: [],
                      claim_id_list: [],
                      maxClaimDate:
                        employerGroupStore?.employerGroupResponseData
                          ?.max_claim_date,
                      ...payload,
                      startDate:
                        employerGroupStore?.selectedDuration?.startDate,
                      endDate: employerGroupStore?.selectedDuration?.endDate,
                    },
                    handleOpenSnackBar,
                    'open',
                  );
                  handleOpenSnackBar(
                    snackBarMessages.SNACKBAR_MESSAGES.OPEN_REPORT,
                    'info',
                    6000,
                  );
                }}
                showQueryDataButton={checkUserAccess(
                  UserAccessConstants.COHORT_DETAILS,
                  loginPageStore.userResponse.role.name,
                  loginPageStore.userFeatures,
                )}
                queryButtonText={
                  cohortDetailsStore.cohortDetailsList?.length > 0 &&
                    cohortDetailsStore.cohortDetailsList[0].category !== ''
                    ? 'Edit Cohort'
                    : 'Add Cohort'
                }
                queryDataAction={() => {
                  if (
                    checkUserAccess(
                      UserAccessConstants.COHORT_DETAILS,
                      loginPageStore.userResponse.role.name,
                      loginPageStore.userFeatures,
                    )
                  ) {
                    openModal();
                  }
                }}
                chip={
                  <div
                    style={{
                      display: 'flex',
                    }}
                  >
                    <Typography
                      fontSize="17px"
                      lineHeight="21px"
                      textColor={patientAccessTheme.palette.text.mediumemphasis}
                      fontType="semiBold"
                      margin="2px 8px 0px 0px"
                    >
                      for
                    </Typography>
                    <Grid className={classes.duration}>
                      {getLast12MonthsRange(
                        employerGroupStore.employerGroupResponseData
                          .max_claim_date,
                      )}
                    </Grid>
                  </div>
                }
                showAskAi={true}
                askAiAction={handleAskAi}
                subTitleStyles={{ width: '700px' }}
              />

              <TabSelection
                selectedTabIndex={selectedTabIndex}
                setSelectedTabIndex={handleSelectedIndex}
                recommendationFetched={recommendationFetched}
              />
            </Grid>
            {selectedTabIndex === 0 && <CareQualityCards />}
            {selectedTabIndex === 1 && (
              <RecommendationsTab
                recommendationLoading={recommendationLoading}
                isInternalPage={true}
              />
            )}
            <div id="scroll-top-element" />
          </Grid>
          {pageScrollDown('scroll-top-element')}
        </div>
      )}
      <Snackbar
        {...snackbarState}
        handleClose={handleCloseSnackBar}
        vertical="bottom"
        horizontal="right"
      />
      <AiSummaryCard
        open={activeAskAi}
        onClose={() => {
          setActiveAskAi(false);
          setAiSummaryData([]);
        }}
        aiSummaryData={aiSummaryData}
        loading={aiLoading}
      />
      <ReportsModal
        open={openReportsModal}
        setOpen={setOpenReportsModal}
        startDate={employerGroupStore?.selectedDuration?.startDate}
        endDate={employerGroupStore?.selectedDuration?.endDate}
      />
      <CohortDetailsModal
        open={open}
        handleClose={closeModal}
        totalResults={totalResults}
        isEditMode={isEditMode}
      />
      <FeatureAccessModal
        open={openFeatureAccessModal}
        handleClose={() => {
          setOpenFeatureAccessModal(false);
        }}
        access={checkUserAccess(
          UserAccessConstants.COHORT_DETAILS,
          loginPageStore.userResponse.role.name,
          loginPageStore.userFeatures,
        )}
      ></FeatureAccessModal>
    </>
  );
});

export default CareQualityPage;
